import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
  name: "PaymentAttributeList",
  components: {
    MainLayout,
    AdvancedLaravelVuePaginate,
    Loading
  },

  data() {
    return {
      isFilterOpen: false,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      paymentAttributeData: {},
      searchData: {
        attribute_name: '',
        is_active: null
      },
      searchedData: null,
      isSearched: false,
      currentPage: 1,
      STATUS: CONFIG.STATUS,
      CATEGORIES: CONFIG.CATEGORIES,
      TYPES: CONFIG.TYPES
    };
  },

  methods: {
    // Get full list
    getAllPaymentAttribute(page = 1) {
      this.currentPage = page;
      this.isLoading = true;
      axios.get('/paymentAttribute/list?page=' + page)
        .then(response => {
          this.paymentAttributeData = response.data;
        })
        .catch(err => {
          if (err.response && err.response.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else {
            console.error(err);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    // Search list
    searchPaymentAttribute(page = 1) {
      this.currentPage = page;
      this.isSearched = true;
      this.isLoading = true;
      // Always copy current search inputs
      this.searchedData = { ...this.searchData };

      axios.get('/paymentAttribute/search?page='+ page, {
        params: {
          attribute_name: this.searchedData.attribute_name,
          is_active: this.searchedData.is_active
        }
      })
      .then(res => {
        if (res.data) {
          this.paymentAttributeData = res.data;
        }
      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else {
          console.error(err);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    // Reset search
    reset() {
      this.searchData.attribute_name = '';
      this.searchData.is_active = null;
      this.searchedData = null;
      this.isSearched = false;
      this.isLoading = true;
      this.getAllPaymentAttribute();
    },

    // Navigation
    showCreate() {
      this.$router.push({ name: 'paymentAttributeCreate' });
    },

    showEdit(id) {
      this.$router.push({ path: `/paymentAttribute/edit/${id}` });
    },

    showDetail(id) {
      this.$router.push({ path: `/paymentAttribute/detail/${id}` });
    },

    // Delete
    confirmDelete(id) {
      if (window.confirm("Are you sure you want to delete this payment attribute?")) {
        this.deletePaymentAttribute(id);
      }
    },

    deletePaymentAttribute(id) {
      this.isLoading = true;
      axios.delete(`/paymentAttribute/delete/${id}`)
        .then(res => {
          if (res.data.success) {
            this.$notification.success('Payment Attribute Deleted Successfully', {
              timer: 3,
              position: "bottomCenter"
            });
            // Refresh the list (current page)
            if (this.isSearched) {
              this.searchPaymentAttribute();
            } else {
              this.getAllPaymentAttribute();
            }
          } else {
            this.$notification.error('Payment Attribute could not be deleted.', {
              timer: 3,
              position: "bottomCenter"
            });
            this.getAllPaymentAttribute();
          }
        })
        .catch(err => {
        if (err.response && err.response.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else {
          this.$notification.error(
            "This attribute is currently in use.",
            {
              timer: 4,
              position: "bottomCenter"
            }
          );
          console.error(err);
        }
        this.isLoading = false;
      });
    }
  },

  mounted() {
    this.isLoading = true;
    this.getAllPaymentAttribute();
  }
};
